import { useWatch } from 'react-hook-form';

import useMediaQuery from '../../../../../../../hooks/useMediaQuery';
import { LetterType } from '../../../../../../../types/api/orders';
import { FormFields } from '../../../CreateEditRecreate.functions';
import InsuredAmount from '../Fields/InsuredAmount';
import PackagingServices from '../Fields/PackagingServices';
import Quantity from '../Fields/Quantity';
import Redemption from '../Fields/Redemption';
import ReferenceNo1 from '../Fields/ReferenceNo1';
import ReturnDocument from '../Fields/ReturnDocument';
import TwoFactorAuthDelivery from '../Fields/TwoFactorAuthDelivery';
import styles from './OrderTypes.module.scss';

function Letter(): JSX.Element {
  const isOnMobile = useMediaQuery('(max-width: 768px)');
  const letter_type_id = useWatch<FormFields, 'letter_type_id'>({
    name: 'letter_type_id',
  });

  return (
    <div
      className={isOnMobile ? styles.twoColumnLayout : styles.fourColumnLayout}
    >
      <Quantity />
      <InsuredAmount />
      <Redemption />
      <ReferenceNo1 />
      <PackagingServices type="letter" />
      {letter_type_id !== LetterType.Regular && <ReturnDocument />}
      {/* Regular letters go into the mailbox, so there is no handover to
          confirm with an OTP code. */}
      {letter_type_id !== LetterType.Regular && <TwoFactorAuthDelivery />}
    </div>
  );
}

export default Letter;
